import dynamic from 'next/dynamic';
import { useWindowWidth } from '@virginexperiencedays/hooks';

import { ReviewsDrawer } from './ReviewsDrawer';
import { ReviewsModal } from './ReviewsModal';
import { ReviewsOverlaySkeleton } from './ReviewsOverlayContent';

import type { Reviews } from '../VariationPage/extractors';

export type ReviewsOverlayProps = Pick<Reviews, 'count' | 'reviews'> & {
  averageRating: Reviews['averageRatingDisplay'];
  open: boolean;
  setOpen: (value: boolean) => void;
  title?: string;
  onExpandCollapse?: (props: {
    currentIndex: number;
    total: number;
    isExpanded: boolean;
    rating: number;
    dateReviewed: string;
    moduleTitle?: string;
    source?: 'modal' | 'drawer';
  }) => void;
};

const ReviewsOverlayContent = dynamic(() => import('./ReviewsOverlayContent'), {
  ssr: false,
  loading: () => <ReviewsOverlaySkeleton />,
});

export const ReviewsOverlay = ({
  averageRating,
  count,
  reviews,
  open,
  setOpen,
  title = 'Customer Reviews',
  onExpandCollapse,
}: ReviewsOverlayProps) => {
  const { isDesktop } = useWindowWidth();

  if (!reviews?.length || !count) return null;

  if (isDesktop()) {
    return (
      <ReviewsModal open={open} setOpen={setOpen} title={title}>
        <ReviewsOverlayContent
          reviews={reviews}
          averageRating={averageRating}
          count={count}
          onExpandCollapse={(data) => {
            onExpandCollapse?.({
              ...data,
              source: 'modal',
            });
          }}
        />
      </ReviewsModal>
    );
  }

  return (
    <ReviewsDrawer open={open} setOpen={setOpen} title={title}>
      <ReviewsOverlayContent
        reviews={reviews}
        averageRating={averageRating}
        count={count}
        onExpandCollapse={(data) => {
          onExpandCollapse?.({
            ...data,
            source: 'drawer',
          });
        }}
      />
    </ReviewsDrawer>
  );
};
